export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ../~/d3-shape/src/array.js
// module id = 8mkF
// module chunks = 0